var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRenew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 3.33366C12.2908 3.33366 14.3127 4.48888 15.5133 6.25033H13.3337V7.91699H18.3337V2.91699H16.667V4.99979C15.1472 2.97671 12.7273 1.66699 10.0003 1.66699C5.39795 1.66699 1.66699 5.39795 1.66699 10.0003H3.33366C3.33366 6.31843 6.31843 3.33366 10.0003 3.33366ZM16.667 10.0003C16.667 13.6822 13.6822 16.667 10.0003 16.667C7.70986 16.667 5.68789 15.5117 4.48735 13.7503H6.66699V12.0837H1.66699V17.0837H3.33366V15.0008C4.8535 17.0239 7.27336 18.3337 10.0003 18.3337C14.6027 18.3337 18.3337 14.6027 18.3337 10.0003H16.667Z",
    fill: "#3A4861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenew);
export default __webpack_public_path__ + "static/media/Renew.4a03852613db2bf95922ef06c826b6d3.svg";
export { ForwardRef as ReactComponent };